module.exports = __webpack_public_path__ + "img/undraw_work_chat_erdt.6cc5a933.svg";